export const account = {
  backLink: 'უკან',
  logout: 'გასვლა',
  title: 'პაროლი და უსაფრთხოება',
  name: {
    label: 'სახელი',
    placeholder: 'შეიყვანეთ სახელი',
    submit: 'ცვლილებების შენახვა',
    tooltip: {
      title: 'თქვენი სახელი უნდა:',
      text: 'იყოს მინიმუმ 3 და მაქსიმუმ 30 სიმბოლო; შეიცავდეს მხოლოდ ასოებს, ციფრებს, სიცარიელეებს, ტირეებს ან ქვედა ხაზებს; არ უნდა შედგებოდეს მხოლოდ სიცარიელეებისგან',
    },
  },
  userSuccess: 'მომხმარებლის მონაცემები წარმატებით განახლდა',
  email: {
    label: 'ელ. ფოსტა',
    placeholder: 'შეიყვანეთ ელ. ფოსტა',
  },
  password: {
    label: 'პაროლი',
    placeholder: 'შეიყვანეთ პაროლი',
    submit: 'პაროლის განახლება',
  },
  passwordNew: {
    placeholder: 'შეიყვანეთ ახალი პაროლი',
    tooltip: {
      title: 'თქვენი პაროლი უნდა შეიცავდეს:',
      text: 'მინიმუმ 5 სიმბოლოს; ასოებს (A-z); ციფრებს (0-9)',
    },
  },
  passwordSuccess: 'პაროლი წარმატებით შეიცვალა',
  warning: {
    title: 'საშიში ზონა',
    text: 'ანგარიშის წაშლის შემდეგ მისი აღდგენა შეუძლებელია.',
  },
  delete: 'ანგარიშის წაშლა',
  deleteConfirm: {
    title: 'ანგარიშის წაშლა',
    description: 'გთხოვთ, დაადასტუროთ ანგარიშის წაშლა\nმიმდინარე პაროლით.',
    password: {
      placeholder: 'პაროლი',
    },
    submit: 'დადასტურება',
  },
  deleteSuccess: 'ანგარიში წარმატებით წაიშალა',
  profile: {
    saveChanges: 'ცვლილებების შენახვა',
    nickname: {
      label: 'მეტსახელი',
      placeholder: 'შეიყვანეთ მეტსახელი',
    },
    password: {
      current: {
        label: 'მიმდინარე პაროლი',
        placeholder: 'შეიყვანეთ მიმდინარე პაროლი',
      },
      new: {
        label: 'ახალი პაროლი',
      },
      repeat: {
        label: 'გაიმეორეთ პაროლი',
        placeholder: 'გაიმეორეთ ახალი პაროლი',
      },
    },
    mfa: {
      title: 'ორფაქტორიანი ავტორიზაცია',
      enabled: 'ჩართულია',
      disabled: 'გამორთულია',
      description:
        'ჩართვის შემდეგ შესვლისას Google Authenticator-ის კოდს მოგთხოვთ.',
      enable: '2FA-ს ჩართვა',
      disable: '2FA-ს გამორთვა',
      disableModal: {
        title: '2FA-ს გამორთვა',
        confirmTitle: 'გამორთვის დადასტურება',
        hint: '2FA-ს გამოსართავად შეიყვანეთ ავთენტიფიკატორის კოდი.',
        placeholder: 'ავთენტიფიკატორის კოდი',
        submit: 'გამორთვა',
      },
      enableModal: {
        title: '2FA-ს ჩართვა',
        checkEmail: 'შეამოწმეთ ელ. ფოსტა',
        hint: 'QR კოდი და საიდუმლო გასაღები გამოგიგზავნეთ ელ. ფოსტაზე. დაასკანირეთ Google Authenticator-ით (ან გამოიყენეთ სათადარიგო ბმული), შემდეგ შეიყვანეთ კოდი ქვემოთ.',
        placeholder: 'ავთენტიფიკატორის კოდი',
        submit: 'ჩართვა',
      },
      toast: {
        disabled: '2FA გამორთულია',
        invalidCode: 'არასწორი კოდი',
        enabled: '2FA ჩართულია',
        setupEmailSent: 'QR კოდისთვის შეამოწმეთ ელ. ფოსტა',
        setupFailed: '2FA-ს ჩართვის დაწყება ვერ მოხერხდა',
      },
    },
    kyc: {
      title: 'იდენტოფიკაცია (KYC)',
      description: 'გამოტანის ჩასართავად დაადასტურეთ ვინაობა.',
      start: 'KYC-ს დაწყება',
      continue: 'KYC-ს გაგრძელება',
      refresh: 'სტატუსის განახლება',
      status: {
        verified: 'დადასტურებული',
        pending: 'დადასტურება მიმდინარეობს',
        actionRequired: 'საჭიროა მოქმედება',
        notVerified: 'არ არის დადასტურებული',
      },
    },
  },
  dob: {
    title: 'დაბადების თარიღი',
    intro: 'გასაგრძელებლად დაამატეთ დაბადების თარიღი.',
    description:
      'აირჩიეთ დაბადების თარიღი ქვემოთ მოცემული სიებიდან. შენახვის შემდეგ დაბრუნდებით წინა გვერდზე.',
    label: 'დაბადების თარიღი',
    day: 'დღე',
    month: 'თვე',
    year: 'წელი',
    submit: 'დაბადების თარიღის შენახვა',
    incomplete: 'აირჩიეთ დღე, თვე და წელი',
    saveFailed: 'დაბადების თარიღის შენახვა ვერ მოხერხდა',
    months: {
      '01': 'იანვარი',
      '02': 'თებერვალი',
      '03': 'მარტი',
      '04': 'აპრილი',
      '05': 'მაისი',
      '06': 'ივნისი',
      '07': 'ივლისი',
      '08': 'აგვისტო',
      '09': 'სექტემბერი',
      '10': 'ოქტომბერი',
      '11': 'ნოემბერი',
      '12': 'დეკემბერი',
    },
  },
  history: {
    title: 'თამაშების ისტორია',
    headers: {
      date: 'თარიღი',
      game: 'თამაში',
      entryFee: 'შესვლის ფასი',
      prize: 'პრიზი',
      result: 'შედეგი',
    },
    result: {
      win: 'მოგება',
      lose: 'მარცხი',
      draw: 'ფრე',
    },
    unknownGame: 'უცნობი',
    empty: 'მატჩები ვერ მოიძებნა',
  },
  achievements: {
    title: 'მიღწევები',
    locked: 'დაბლოკილი',
    earned: 'მიღებული: {{date}}',
    empty: 'მიღწევები ჯერ არ გაქვს',
    items: {
      'first-win': {
        name: 'პირველი მოგება',
        description: 'მოიგე პირველი თამაში',
      },
      'quick-win': {
        name: 'სწრაფი მოგება',
        description: 'მოიგე 60 წამში',
      },
      'one-on-one-win': {
        name: '1v1 გამარჯვებული',
        description: 'მოიგე 1v1 მატჩი',
      },
      'login-streak-30': {
        name: '30-დღიანი სერია',
        description: 'შედი 30 დღე ზედიზედ',
      },
      'login-streak-60': {
        name: '60-დღიანი სერია',
        description: 'შედი 60 დღე ზედიზედ',
      },
    },
  },
};
